import {
  CreateUpdateReceiptDto,
  CreateUpdateReceiptPositionDto,
  CreateUpdateReceiptPositionDtoVatEnum,
  DefaultApi,
  GetReceiptDto,
  ReceiptItemDto,
} from '../autogenerated/spdApiClient';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { receiptForGrid } from '../../../spd/components/Receipt/ReceiptsSearch';

export type { CreateUpdateReceiptDto, GetReceiptDto };

export interface ReceiptContextInterface {
  create: (dto: CreateUpdateReceiptDto) => Promise<GetReceiptDto>;
  getById: (id: string) => Promise<GetReceiptDto>;
  getByExamId: (examId: string) => Promise<GetReceiptDto[]>;
  update: (id: string, dto: CreateUpdateReceiptDto) => Promise<GetReceiptDto>;
  fiscalize: (
    id: string,
    jpkid: number,
    printerUid: string | null,
  ) => Promise<GetReceiptDto>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, filterColumns?: string) => Promise<number>;
}

export const ReceiptContext = (api: DefaultApi): ReceiptContextInterface => ({
  create: (dto: CreateUpdateReceiptDto) => api.receiptControllerCreate(dto),
  getById: (id: string) => api.receiptControllerGet(id),
  getByExamId: (examId: string) => api.receiptControllerGetByExam(examId),
  update: (id: string, dto: CreateUpdateReceiptDto) =>
    api.receiptControllerUpdate(id, dto),
  fiscalize: (id: string, jpkid: number, printerUid: string | null) =>
    api.receiptControllerUpdate(id, {
      fiscalized: true,
      jpkId: jpkid,
      printerUid,
    }),
  async getAllByPortion(
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    filterColumns?: string,
  ) {
    const response = await api.receiptControllerGetAllByPortion(
      pageSize,
      pageNumber,
      orderBy || '',
      orderDirection || '',
      filterText || '',
      filterColumns,
    );
    return response.map(receiptForGrid);
  },
  getAllCount: (filterText?: string, filterColumns?: string) =>
    api.receiptControllerGetAllCount(filterText || '', filterColumns),
});

export const mapReceiptItemsToPositions = (
  items: ReceiptItemDto[],
): CreateUpdateReceiptPositionDto[] =>
  items.map((item, index) => ({
    name: item.name,
    amount: item.price,
    vat: item.vat as unknown as CreateUpdateReceiptPositionDtoVatEnum,
    quantity: item.quantity,
    order: index + 1,
  }));
